import { TOUR_IDS, type TourId } from "./types";

const key = (userId: string) => `hub.tutorialsSeen.${userId}`;

const isTourId = (v: unknown): v is TourId =>
  typeof v === "string" && (TOUR_IDS as readonly string[]).includes(v);

/**
 * This browser's copy of the tours a person has seen. The server map is the
 * source of truth; this covers the moment before /user loads and a POST
 * that failed, so a tour can't flash twice. Storage can be unavailable
 * (private windows), so every access is guarded.
 */
export const readSeen = (userId: string): Set<TourId> => {
  try {
    const parsed = JSON.parse(window.localStorage.getItem(key(userId)) ?? "[]");
    return new Set(Array.isArray(parsed) ? parsed.filter(isTourId) : []);
  } catch {
    return new Set();
  }
};

export const writeSeen = (userId: string, seen: Iterable<TourId>): void => {
  try {
    window.localStorage.setItem(key(userId), JSON.stringify(Array.from(seen)));
  } catch {
    // The server copy still suppresses it on the next load.
  }
};

export const mergeSeen = (
  server: Record<string, string> | null | undefined,
  local: Iterable<TourId>,
): Set<TourId> =>
  new Set([...Object.keys(server ?? {}).filter(isTourId), ...Array.from(local)]);
